module.exports = __webpack_public_path__ + "components/country-flag/static/bi-98bb157807a89729d83c85d2f11b1d30.svg";